import type { TypedUseSelectorHook } from 'react-redux';
import {  useDispatch, useSelector }  from 'react-redux';
import type { AnyAction } from 'redux';
import type { ThunkAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { flowSlice } from './flow';
import { userSlice } from './user';
import { authorizedOfficerSlice } from './authorizedOfficer';
import { companySlice } from './company';
import { phoneSlice } from './phone';
import { newUserSlice } from './newUserState';
import { permissionsSlice } from './permissions';

export const store = configureStore({
    reducer: {
        [flowSlice.name]: flowSlice.reducer,
        [userSlice.name]: userSlice.reducer,
        [authorizedOfficerSlice.name]: authorizedOfficerSlice.reducer,
        [companySlice.name]: companySlice.reducer,
        [phoneSlice.name]: phoneSlice.reducer,
        [newUserSlice.name]: newUserSlice.reducer,
        [permissionsSlice.name]: permissionsSlice.reducer
    },
    devTools: true,
});

// export type AppStore = ReturnType<typeof store>;
export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = Promise<void>> = ThunkAction<
    ReturnType,
    AppState,
    unknown,
    AnyAction
>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
